//兼容微信、钉钉、嘉扬app外壳
//不同环境下引用不同的适配器js。但vue组件中调用时，都使用nativeAdapter中的方法来统一调用，不要每次都去判断一遍当前环境了

import dingtalk from './dingtalk';
import kayang from './kayang';
import wechat from './wechat';

var adapter = {
    ...getAppEnv(),
    ...getAdpater()
}
setDate()
export default adapter

function getAdpater() {
    var ua = getUA()
    if (ua.match(/dingtalk/i)) {
        return dingtalk
    } else if (ua.match(/MicroMessenger/i)) {
        return wechat
    } else {
        return kayang
    }
}

function getAppEnv() {
    var ua = getUA()
    var isIos = /iPhone/i.test(ua)
    return {
        isIos,
        isIosX: isIos && screen.height >= 812,
        isAndroid: /Android|Linux/i.test(ua),
    }
}
function setDate() {
    // ios13及以下系统对时间解析与其他系统不一致
    // 例 new Date('2022-10-11T03:00:00') 会解析到11:00:00,自动加上时差
    // 使用ios版本判断在PC端模拟ios会显示错误，因为PC端模拟的是ios13
    // var ua = getUA()
    // var exec = /\iPhone OS\ (.+?) \like/.exec(ua);
    // if (exec && exec.length) {
    //     var iosVersion = exec[1];
    //     var v1 = iosVersion.split('_')[0];
    //     if (Number(v1) <= 13) {
    //     }
    // }
    // 使用日期时间戳判断,如果加和不加时区Z结果相同,则改写date 手动加上时差
    const date1 = new Date('2022-01-01T08:00:00').valueOf();
    const date2 = new Date('2022-01-01T08:00:00Z').valueOf();
    if (date1 === date2) {
        window.Date = class IosDate extends Date {
            constructor(v1, v2, v3, v4, v5, v6, v7) {
                var arglen = arguments.length;
                if (arglen === 0) super();
                else if (arglen === 1) super(v1);
                else super(v1, v2, v3 || 1, v4 || 0, v5 || 0, v6 || 0, v7 || 0);
                if (arglen === 1 && /\d+\-\d+\-\d+T\d+:\d+:\d+\.?\d*$/.test(v1)) {
                    this.setMinutes(this.getMinutes() + new Date().getTimezoneOffset())
                }
            }
        }
    }
}

function getUA() {
    return navigator.userAgent
}